<template>
  <div class="nav-bar" style="background-color: white">
    <div v-if="searchErrorMessage" style="text-align: center; margin-top: 1rem">
      {{ searchErrorMessage }}
    </div>
    <div v-if="searchErrorMessage || searchResult || searchOrderLoading">
      <div v-for="(item, date) in searchResult" :key="date">
        <div v-for="(orders, status) in item" :key="orders.priority">
          <div v-if="orders.items.length > 0">
            <div v-if="canShowItems(status)">
              <div class="search-result-title">
                <p>{{ status }} ({{ orders.items.length }})</p>
                <p>{{ date }}</p>
              </div>
              <CardOrderHistory
                @onclick="ShowDirection"
                v-for="order in orders.items"
                :key="order.id"
                :id="order.id"
                :time="order.time"
                :date="order.date.date"
                :distance="order.distance"
                :rating="order.rating"
                :name="order.name"
                :price="order.price"
                :status="order.status"
                :driverName="order.driverName"
                :origin="order.origin"
                :destination="order.destination"
                :updatedAt="order.updatedAt"
                :lalamoveTag="
                  matchLalamoveWithVilla({ villaID: order.id, riderType: order.riderType })
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="orderList">
      <div class="filter">
        <b-button
          :loading="loading"
          @click="onClickReport"
          size="is-small"
          type="is-info"
          icon-right="file-chart"
          >Report</b-button
        >
      </div>
      <div v-if="isOrderEmpty" style="text-align: center; padding-top: 1rem">
        ไม่พบรายการคำสั่งซื้อ
      </div>
      <div v-for="(item, date) in orderList" :key="date">
        <div v-for="(orders, status) in item" :key="orders.priority">
          <div v-if="orders.items.length > 0">
            <div v-if="canShowItems(status)">
              <div class="title">
                <p>{{ status }} ({{ orders.items.length }})</p>
                <p>{{ date }}</p>
              </div>
              <CardOrderHistory
                @onclick="ShowDirection"
                v-for="order in orders.items"
                :key="order.id"
                :id="order.id"
                :time="order.time"
                :date="order.date.date"
                :distance="order.distance"
                :rating="order.rating"
                :name="order.name"
                :price="order.price"
                :status="order.status"
                :driverName="order.driverName"
                :origin="order.origin"
                :destination="order.destination"
                :updatedAt="order.updatedAt"
                :lalamoveTag="
                  matchLalamoveWithVilla({ villaID: order.id, riderType: order.riderType })
                "
              />
              <div
                v-if="nextToken[date][status]"
                @click="onLoadmoreData(date, status)"
                class="icon-loadmore"
              >
                <b-icon icon="arrow-down-drop-circle-outline" size="is-medium"> </b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getBranchAddress } from "@/settings/branchs";
import relativeTime from "dayjs/plugin/relativeTime";
import { statusByRouteName } from "@/settings/orderStatus";

dayjs.extend(relativeTime);
export default {
  name: "HistoryOrder",
  components: {
    CardOrderHistory: () => import("@/components/CardOrderHistory"),
    // CardShipping: () => import("@/components/CardShipping"),
  },
  computed: {
    // getDistance() {
    //   return async (order) => {
    //     console.log(order);
    //     // if (order.distance === "XX") {
    //     //   console.log("xx");
    //     // }
    //     return order.distance;
    //   };
    // },
    orderList() {
      return this.$store.getters["orders/orders"];
    },
    nextToken() {
      return this.$store.getters["orders/nextToken"];
    },
    filter() {
      return this.$store.getters["orders/filter"];
    },
    reportOrder() {
      return this.$store.getters["orders/reportOrder"];
    },
    reportOrderLalamove() {
      return this.$store.getters["lalamove/reportOrderLalamove"];
    },
    lalamoveOrderList() {
      return this.$store.getters["lalamove/completedOrderLalamove"];
    },
    driverName() {
      return (order) => {
        console.log("driverName");
        if (order.driverName) {
          return order.driverName;
        } else if (order.riderType === "LLM") {
          return "LALAMOVE";
        } else {
          this.getDriverName(order.driverID);
          return order.driverID;
        }
      };
    },
    isOrderEmpty() {
      const status = statusByRouteName[this.$route.name];
      return this.$store.getters["orders/isOrderEmpty"](status);
    },
    searchResult() {
      return this.$store.getters["orders/searchResult"];
    },
    searchErrorMessage() {
      return this.$store.getters["orders/searchErrorMessage"];
    },
    searchOrderLoading() {
      return this.$store.getters["orders/searchOrderLoading"];
    },
    loadingOrder() {
      return this.$store.getters["orders/loadingOrder"];
    },
  },
  data() {
    return {
      loading: false,
      isLoading: null,
    };
  },
  async mounted() {
    // const headers = {
    //   phone_no: "phone_no",
    //   name: "name",
    //   licenseplate: "licenseplate",
    // };
    // const fileTitle = "driver_villa"; //
    // const result = await this.$store.dispatch("drivers/listDriver");
    // const data = result.data.listDrivers.items;
    // let itemsFormatted = [];
    // for (let i = 0; i <= data.length - 1; i++) {
    //   let driver = data[i];
    //   itemsFormatted.push({
    //     phone_no: driver.phone_no,
    //     name: driver.name,
    //     licenseplate: driver.licenseplate,
    //   });
    // }
    // console.log(itemsFormatted);
    // this.exportCSVFile(headers, itemsFormatted, fileTitle);
    this.$store.commit("orders/setEmptyOrders");
    this.GetOrderList();
  },
  watch: {
    loadingOrder() {
      console.log("loadingOrder", this.loadingOrder);
      if (!this.loadingOrder) {
        this.isLoading = this.$buefy.loading.open();
      } else {
        if (this.isLoading) {
          this.isLoading.close();
        }
      }
    },
    searchOrderLoading() {
      console.log("searchOrderLoading", this.searchOrderLoading);
      if (this.searchOrderLoading) {
        this.isLoading = this.$buefy.loading.open();
      } else {
        if (this.isLoading) {
          this.isLoading.close();
        }
      }
    },
  },
  methods: {
    matchLalamoveWithVilla({ villaID, riderType }) {
      if (riderType === "LLM") {
        let lalamoveOrderID = this.lalamoveOrderList.find((i) => i.villaOrderID === villaID);
        if (lalamoveOrderID) {
          lalamoveOrderID = lalamoveOrderID.id;
        }
        return { riderType, lalamoveOrderID };
      } else {
        return { riderType: "VL", lalamoveOrderID: null };
      }
    },
    getDistance(order) {
      if (order.distance === "XX") {
        const address = getBranchAddress(order.origin);
        this.$store.dispatch("position/getDistance", {
          origin: address.address,
          destination: order.destination,
        });
      }
      return order.distance;
      // console.log(result);
    },
    ShowDirection(position) {
      console.log(position);
    },
    async GetOrderList() {
      this.$store.commit("orders/setLoadingOrder", false);
      await Promise.all([
        await this.$store.dispatch("orders/getOrders", { status: "SUCCESS" }),
        await this.$store.dispatch("lalamove/getOrdersLalamove", { status: "COMPLETED" }),
      ]);
      this.$store.commit("orders/setLoadingOrder", true);
    },
    async onLoadmoreData(date, status) {
      console.log(date);
      if (this.filter) {
        console.log(this.filter, this.nextToken);
        await this.$store.dispatch("orders/getOrdersWithFilter", {
          ...this.filter,
          date: date,
          status: status,
          nextToken: this.nextToken[date][status],
        });
      } else {
        await this.$store.dispatch("orders/getOrders", {
          status: status,
          nextToken: this.nextToken[date][status],
        });
      }
    },
    async onClickReport() {
      this.loading = true;
      let date = "";
      if (this.filter) {
        date = this.filter.date;
        console.log(this.filter);
      } else {
        this.loading = false;
        return;
      }

      await this.generateOrderReport(date, "SUCCESS", "COMPLETED");
      await this.generateOrderReport(date, "PICKUP", "ON_GOING");
      await this.generateOrderReport(date, "DELIVERING", "PICKED_UP");

      this.loading = false;
    },

    sanitizeText(text) {
      if (!text) return '';
      // Remove commas, quotes, newlines, and other special characters
      return String(text).replace(/[,"\n\r]/g, ' ').trim();
    },

    async generateOrderReport(date, villaOrderStatusName, lalamoveOrderStatusName) {
      console.log(`Generating ${villaOrderStatusName} orders report...`);
      await this.$store.dispatch("orders/GetOrderByStatusDeliveryDate", {
        status: villaOrderStatusName,
        sTime: this.filter.date,
        nTime: this.filter.endTime,
      });
      await this.$store.dispatch("lalamove/getOrdersByStatusDeliveryDateLalamove", {
        status: lalamoveOrderStatusName,
        sTime: this.filter.date,
        nTime: this.filter.endTime,
        onReport: true,
      });
      console.log("LALAMOVE ORDER LOGGGG >>>>", this.reportOrderLalamove);
      const reportData = this.reportOrder;
      console.log(reportData);
      const headers = {
        orderID: "OrderID",
        date: "date",
        deliveryMode: "deliveryMode",
        slottime: "slottime",
        endSlot: "endSlot",
        actualDeliveryDate: "actualDeliveryDate",
        findDriver: "findDriver",
        // waitingTime: "waitingTime",
        startJob: "startJob",
        endJob: "endJob",
        duration: "duration",
        distance: "distance",
        driverName: "driverName",
        branch: "branch",
        carType: "carType",
        // riderType: "riderType",
        orderSource: "Channel",
        appVersion: "appVersion",
        lalamoveOrderID: "lalamoveOrderID",
        destination: "destination",
      };
      const fileTitle = `report-order-${villaOrderStatusName}_(${date}-${this.filter.endTime})`;
      let itemsFormatted = [];

      reportData.forEach((order) => {
        if (order.id.includes("Test") || order.id.includes("test") || order.id.includes("TEST")) {
          return;
        }
        let lalamoveOrderID = this.reportOrderLalamove.find((i) => i.villaOrderID === order.id);
        if (lalamoveOrderID) {
          lalamoveOrderID = lalamoveOrderID.id || "";
        } else {
          lalamoveOrderID = "";
        }

        let dateStart;
        let dateEnd;

        // console.log("csv: ", order.id, order.logOrder.items);
        // order.logOrder.items.sort((a,b) => {
        //   return  a.localeCompare(b);
        // })

        let logOrder = order.logOrder.items;

        logOrder.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

        let startJob = logOrder.filter((element) => {
          return element.status === "PICKUP";
        });

        let findDriver = logOrder.filter((element) => {
          return element.status === "FINDDRIVER";
        })

        // console.log("csv: ", order.id, order.logOrder.items, startJob, findDriver);

        if (startJob.length && findDriver.length) {
          // let waitingTime = dayjs(startJob[0].createdAt).diff(dayjs(findDriver[0].createdAt), "minutes");

          const tempStartJob = startJob[startJob.length-1].createdAt;
          startJob = startJob[startJob.length-1].createdAt;
          dateStart = dayjs(startJob);
          startJob = dayjs(startJob).format("HH:mm:ss");

          findDriver = findDriver[0].createdAt;

          findDriver = dayjs(findDriver).format("HH:mm:ss");


          let endJob = order.logOrder.items.filter((element) => {
            return element.status === "SUCCESS";
          });

          let floatDuration = null;
          let tempEndJob = null;

          if (endJob.length) {
            tempEndJob = endJob[endJob.length-1].createdAt;
            dateEnd = dayjs(tempEndJob);
            tempEndJob = dayjs(tempEndJob).format("HH:mm:ss");

            let duration = dateEnd.diff(dateStart, "minutes");
            let durationHour = 0;
            let durationMinute = 0;
            let textDuration = ``;
            durationHour = parseInt(duration / 60);
            durationMinute = duration % 60;
            durationMinute = durationMinute.toString();
            durationMinute = durationMinute.padStart(2, "0");
            textDuration = `${durationHour.toString()}.${durationMinute}`;
            floatDuration = parseFloat(textDuration);
            console.log(typeof floatDuration);
          }

          let endSlotH = parseInt(order.time.split(":")[0]) + 1;
          let endSlotM = order.time.split(":")[1];

          let distance = "";
          if (order.distance) {
            distance = order.distance.replace(",", "");
          }

          if (distance.includes("KM")) {
            distance = distance.replace("KM", "");
          }

          if (distance.includes("km")) {
            distance = distance.replace("km", "");
          }

          if (distance.includes("m")) {
            distance = distance.replace("m", "");

            let distanceFloat = parseFloat(distance);
            distance = (distanceFloat/1000).toString();
          }


          if (findDriver > startJob){ // swap
            let t = startJob
            startJob = findDriver
            findDriver = t
          }

          if (order.id && order.id.startsWith("T")) {
            order.orderSource = "SALE_PORTAL";
          }

          itemsFormatted.push({
            orderID: order.id,
            date: order.deliveryDate,
            deliveryMode: order.deliveryMode,
            slottime: order.time,
            endSlot: `${endSlotH}:${endSlotM}`,
            deliveryDate: dayjs(tempStartJob).format("YYYY-MM-DD"),
            findDriver: findDriver,
            // waitingTime: waitingTime,
            startJob: startJob,
            endJob: tempEndJob,
            duration: floatDuration,
            distance: distance,
            driverName: order.driverName,
            branch: order.origin,
            carType: order.carType,
            // riderType: order.riderType,
            orderSource: order.orderSource,
            appVersion: order.ver,
            lalamoveOrderID: lalamoveOrderID,
            destination: this.sanitizeText(order.destination),
          });
        }
      });

      itemsFormatted.sort(
        (a, b) => a.date.localeCompare(b.date) || a.slottime.localeCompare(b.slottime)
      );
      this.exportCSVFile(headers, itemsFormatted, fileTitle);
    },

    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);
      var csv = this.convertToCSV(jsonObject);
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";

          // Escape CSV field: wrap in quotes if contains comma, quote, or newline
          var value = array[i][index];
          if (value != null) {
            value = String(value);
            // Escape double quotes by doubling them
            if (value.includes('"')) {
              value = value.replace(/"/g, '""');
            }
            // Wrap in quotes if contains comma, quote, or newline
            if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
              value = '"' + value + '"';
            }
          } else {
            value = '';
          }

          line += value;
        }
        str += line + "\r\n";
      }
      return str;
    },
    canShowItems(status) {
      const allowedStatus = statusByRouteName[this.$route.name] ?? [];
      // console.log("canShowItems", status, allowedStatus);

      // search mode
      // const isSearchOrderMode = this.$store.getters["orders/isSearchOrderMode"];
      // if (isSearchOrderMode) {
      //   status = "ALL";
      // }

      // if (this.selectedStatus !== "ALL") {
      //   return status === this.selectedStatus;
      // }

      return allowedStatus.includes(status);
    },
  },
};
</script>
<style scoped>
.title {
  z-index: 10;
  font-size: 15px;
  padding: 10px;
  margin: 0;
  position: sticky;
  background-color: white;
  top: 25px;
  display: flex;
  justify-content: space-between;
}
.search-result-title {
  z-index: 10;
  font-size: 15px;
  padding: 10px;
  margin: 0;
  position: sticky;
  top: 0px;
  background-color: white;
  display: flex;
  justify-content: space-between;
}
.icon-loadmore {
  padding: 5px;
  text-align: center;
  cursor: pointer;
}
.filter {
  justify-content: flex-end;
  display: flex;
  position: sticky;
  z-index: 20;
  top: 0px;
  background: white;
}
</style>
